App.OrdersTableRowComponent = Em.Component.extend
  env:      Em.inject.service('environment')
  session:  Em.inject.service('session')
  realTime: Em.inject.service('realTime')

  classNames: ['order-table-row']

  classNameBindings: [
    'isUnread'
  ]

  tagName: 'tr'

  showedTableRows: null

  newOrderIds: Em.computed.alias('realTime.newOrderIds')

  isUnread: (->
    @get('order.id') in @get('newOrderIds')
  ).property('newOrderIds.[]', 'order.id')

  translatedStatus: (->
    st = "order.status.#{@get('order.status')}"
    if @get('env').has_translation_for st
      @get('env').translate st
    else
      @get('order.status')
  ).property('order.status')

  translatedSource: (->
    src = "clients.order_source.#{@get('order.source')}"
    if @get('env').has_translation_for src
      @get('env').translate src
    else
      @get('order.source')
  ).property('order.source')

  translatedPaymentSource: (->
    ps = "order.payment_method.#{@get('order.payment_source')}"
    if @get('env').has_translation_for ps
      @get('env').translate ps
    else
      @get('order.payment_source')
  ).property('order.payment_source')

  publishedAtHumanize: (->
    m = moment(@get('order.published_at')).tz(@get('order.timezone'))
    if moment().isSame(m, 'day')
      # todo i18n
      return m.format('сегодня HH:mm')

    m.format('DD.MM.YYYY в HH:mm')
  ).property('order.published_at')

  deliveryAtHumanize: (->
    m = moment(@get('order.delivery_at')).tz(@get('order.timezone'))
    if moment().isSame(m, 'day')
      # todo i18n
      return m.format('сегодня HH:mm')
    m.format('D MMMM, HH:mm')
  ).property('order.delivery_at')

  deliveryAtRangeHumanize: (->
    return if Em.isEmpty(@get('order.delivery_at_range'))

    fromDate = @get('order.delivery_at_range')[0]
    toDate = @get('order.delivery_at_range')[1]

    mFrom = moment(fromDate).tz(@get('order.timezone'))
    mTo = moment(toDate).tz(@get('order.timezone'))

    day = if moment().isSame(mFrom, 'day') then @get('env').translate('date.today') else mFrom.format('D MMMM')
    hFrom = mFrom.format('HH:mm')
    hTo = mTo.format('HH:mm')

    @get('env').translate("orders.table.content.delivery_at_range", day: day, from: hFrom, to: hTo)
  ).property('order.delivery_at_range')

  posStatus: (->
    params = @get('order.integration_params')
    return '' unless params

    pos = ['iiko','poster','carbis','frontpad', 'iiko_transport', 'procart', 'rk_delivery', 'sbis'].find (v) -> params.hasOwnProperty v
    return '' unless pos

    return 'error' if params[pos].error
    return 'pending' if Em.isEmpty(params[pos].external_id) || params[pos].external_id == 'export_pending'

    'success'
  ).property('order.integration_params')

  translatedPosStatus: (->
    ps =  "order.pos_status.#{@get('posStatus')}"

    if @get('env').has_translation_for ps
      @get('env').translate ps
    else
      ''
  ).property('posStatus')

  paymentStatus: (->
    return '' unless @get('order.isPaymentCard')

    if @get('order.payment_success') or @get('order.final_sum') == 0
      'payment-success'
    else
      'payment-fail'
  ).property(
    'order.isPaymentCard',
    'order.payment_success',
    'order.final_sum'
  )

  paymentComment: (->
    switch @get('paymentStatus')
      when 'payment-fail'
        # todo i18n
        'Заказ еще не был оплачен'
      when 'payment-success'
        # todo i18n
        'Заказ оплачен'
      else
        null
  ).property('paymentStatus')


  commentExpanded: false

  actions:
    toggleComment: ->
      @toggleProperty('commentExpanded')
      false

    onNumberClicked: ->
      @sendAction('numberClicked', @get('order'))
      false

    onStatusClicked: ->
      @sendAction('statusClicked', @get('order'))
      false

    onDatetimeClicked: ->
      @sendAction('datetimeClicked', @get('order'))
      false

    onCourierClicked: ->
      @sendAction('courierClicked', @get('order'))
      false

